export const hasRole = (role: string, check: string) => role.split(",").includes(check)

export const addRole = (role: string, add: string) =>
  hasRole(role, add) ? role : `${role},${add}`

export const removeRole = (role: string, remove: string) =>
  role
    .split(",")
    .filter((r) => r !== remove)
    .join(",")

export const isPortalAdmin = (role: string) =>
  hasRole(role, "portal-owner") || hasRole(role, "portal-admin")

export const getRoles = (role: string) => role.split(",")
